import { useContext } from "react"
import AuthContext from "./auth-context"

export default () => useContext(AuthContext)
